import { Box, Card, CardContent, Grid, Link, Typography } from "@mui/material";
import React from "react";

const ADVISORS = [
    { name: "Eli Taylor", title: "Lead Technical Consultant", link: "https://www.linkedin.com/in/elitaylor/" },
    { name: "Kyjeila Latimer, PhD", title: "Lead Data Analysis and Compliance Consultant", link: "https://www.linkedin.com/in/kyjeila-latimer-ph-d-3879b6187/" },
    { name: "Cathy Barragan", title: "Lead Brand Marketing and Internal Operations Consultant", link: "https://www.linkedin.com/in/cathybarragan/" },
    { name: "Janine Oneill", title: "Early Stage Talent Development Advisor, Executive Coach", link: "https://www.linkedin.com/in/janine-o-neill-she-her-81629/" },
    { name: "Teddy Shalon", title: "Lead Business Development Advisor", link: "https://www.linkedin.com/in/teddyshalon/" },
    { name: "Ted Paff", title: "Lead Business Finance Advisor", link: "https://www.linkedin.com/in/ted-paff-5323602/" },
    { name: "Trevin York", title: "Lead Product Development Advisor", link: "https://www.linkedin.com/in/trevin-york/" },
    { name: "Jonathan Wheat", title: "Lead Risk Advisor", link: "https://www.linkedin.com/in/jonathan-wheat-cpcu-cris-abb24a49/" },
    { name: "Dr. Kim Moses", title: "Lead Education Operations Advisor", link: "https://www.linkedin.com/in/kim-moses-6b513550/" },
    { name: "Scott Hanselman", title: "Lead Tech Development Advisor", link: "https://www.linkedin.com/in/shanselman/" },
    { name: "Brandy Spong", title: "Education Policy Advisor", link: "https://www.linkedin.com/in/brandy-spong/" },
    { name: "Aren Ulmer, MA, CMPC, MHFA", title: "Lead Sports Mental Performance Advisor", link: "https://www.linkedin.com/in/aren-ulmer/" },
    { name: "Matthew Dedon", title: "Lead Legal & Compliance Consultant", link: "https://www.linkedin.com/in/matthew-dedon/" }
];

const Advisors: React.FC = () => {
    return (
        <Box sx={{ mb: 8 }}>
            <Typography
                variant="h3"
                component="h2"
                sx={{
                    textAlign: "center",
                    mb: 6,
                    fontWeight: "bold"
                }}
            >
                Advisors
            </Typography>

            <Grid container spacing={3}>
                {ADVISORS.map((advisor, idx) => (
                    <Grid item xs={12} sm={6} md={4} key={idx}>
                        <Card
                            component={Link}
                            href={advisor.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            elevation={2}
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                transition: "transform 0.2s ease-in-out",
                                textDecoration: "none",
                                color: "inherit",
                                "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: 4,
                                    textDecoration: "none"
                                }
                            }}
                        >
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography
                                    variant="h6"
                                    component="h3"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "primary.main",
                                        mb: 0.5
                                    }}
                                >
                                    {advisor.name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.5 }}>
                                    {advisor.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Advisors;
